import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';
import {StaticMethods} from '../model/GeneralModels';

@Injectable({
  providedIn: 'root'
})
export class ExternalEmployeeService {

  constructor(private authService: AuthService,
              private http: HttpClientWrapperService) {
  }

  getEmployeeProducts() {
    return this.http.get('external-employee/products', this.authService.decode().auth);
  }

  getRequestsCount(productName: string) {
    return this.http.get(`external-employee/${productName}/count`, this.authService.decode().auth);
  }

  getEmployeeRequests(productName: string, mode: string) {
    return this.http.get(`external-employee/${productName}/${mode}`, this.authService.decode().auth);
  }

  getRequestDetails(productName: string, id: number) {
    return this.http.get(`external-employee/${productName}/details/${id}`, this.authService.decode().auth);
  }

  releaseIntroductionLetter(id: number, productName: string, file: File) {
    return this.http.upload(`external-employee/${productName}/release/${id}`, file, 'IntroductionLetter', this.authService.decode().auth);
  }

  downloadFile(id: number, fileType: string, productName: string) {
    this.http.get(`external-employee/${productName}/download/${fileType}/${id}/directLink`, this.authService.decode().auth)
      .subscribe(response => {
        if (response.success) {
          StaticMethods.goToLink(response.data.directLink);
        }
    });
  }

  submitReply(id: number, productName: string, reply: string, input: string) {
    return this.http.post(`external-employee/${productName}/submitReply/${id}`, {
      reply,
      input
    }, this.authService.decode().auth);
  }
}
